import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { Mission } from "@/components/site/Mission";
import { FounderStrip } from "@/components/site/FounderStrip";
import { Rewards } from "@/components/site/Rewards";
import { Milestones } from "@/components/site/Milestones";
import { Tokenomics } from "@/components/site/Tokenomics";
import { MiniGame } from "@/components/site/MiniGame";
import { Impact } from "@/components/site/Impact";
import { SoundToggle } from "@/components/site/SoundToggle";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain relative bg-[#050505] text-white" data-testid="landing-page">
      <Toaster position="bottom-center" theme="dark" />
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Mission />
        <FounderStrip />
        <Rewards />
        <Milestones />
        <Tokenomics />
        <MiniGame />
        <Impact />
      </main>
      <SoundToggle />
      <Footer />
    </div>
  );
}
